// extracted by mini-css-extract-plugin
export default {"richBody":"styles_richBody__SVBa2","clamped":"styles_clamped__YPQsh","seeMore":"styles_seeMore__tE+6Q"};